export const PossibleFeaturesMap = {
  Debug: [false, true],
  LogAnalyticsEventsToConsole: [false, true],
  FillAds: ["default", "never", "alwaysWithTestAds"],
  CmpConsent: ["grant", "deny", "dynamic"],
  GoogleMapsChannel: ["", "alpha", "beta", "weekly", "quarterly"],

  // Don't delete, required for content-test
  SkipRoutes: ["skip", "noSkip", "breadcrumbs"],
  UseStaticConnectedSchedules: [
    "never",
    "FullyScheduleableNonBookableRoutes",
    "FullyBookableRoutesFallback",
    "FirstOrLastWalkingSegmentRoutes",
  ],
  ForceUseLiveScheduleFallback: [false, true],
  UseDarkMode: [false, true],
  KayakInlineAds: [false, true],
  DelayPrebidUntilConsentReady: [false, true],
  ReactQueryDevTools: [false, true],
  FreelancerQA: ["default", "login", "hide"],
  DataOpsQA: [false, true],
  IslandRoutingQA: [false, true],
  FilterAndSortQA: [false, true],
  MapPinAds: [false, true],
  KoddiDestinationBranding: [false, true],
  KoddiSponsoredHotelListing: ["Baseline", "PinkCard", "BlackCard", "ViewDeal"],
  KoddiSponsoredHotelQA: [false, true],
  DisableDatePopupMobile: [false, true],
  DatesSearchBar: ["Baseline", "Visible", "VisibleAuto"],
  DriveRoutes: [false, true],
  RefreshAdUnits: [false, true],
  HotelPromoDriveSegment: [false, true],
  MapMarkerLabels: [false, true],
} as const;

export const defaultFeatureConfig: FeatureConfig = {
  Debug: parseBooleanEnv(import.meta.env.VITE_FEATURE_DEFAULT_DEBUG, false),
  LogAnalyticsEventsToConsole: parseBooleanEnv(
    import.meta.env.VITE_FEATURE_DEFAULT_LOG_ANALYTICS_EVENTS_TO_CONSOLE,
    false,
  ),
  FillAds: import.meta.env.VITE_FEATURE_DEFAULT_FILL_ADS ?? "default",
  CmpConsent: import.meta.env.VITE_FEATURE_DEFAULT_CMP_CONSENT ?? "dynamic",
  GoogleMapsChannel: "",
  SkipRoutes: import.meta.env.VITE_FEATURE_DEFAULT_SKIP_ROUTES ?? "skip",
  UseStaticConnectedSchedules: "FirstOrLastWalkingSegmentRoutes",
  ForceUseLiveScheduleFallback: false,
  UseDarkMode: false,
  KayakInlineAds: true,
  DelayPrebidUntilConsentReady: parseBooleanEnv(
    import.meta.env.VITE_FEATURE_DEFAULT_DELAY_PREBID_UNTIL_CONSENT_READY,
    true,
  ),
  ReactQueryDevTools: false,
  FreelancerQA: "default",
  DataOpsQA: false,
  IslandRoutingQA: false,
  FilterAndSortQA: false,
  MapPinAds: false,
  KoddiDestinationBranding: false,
  KoddiSponsoredHotelListing: "Baseline",
  KoddiSponsoredHotelQA: false,
  DisableDatePopupMobile: false,
  DatesSearchBar: "Baseline",
  RefreshAdUnits: false,
  DriveRoutes: false,
  HotelPromoDriveSegment: false,
  MapMarkerLabels: false,
};

function parseBooleanEnv(
  value: string | undefined,
  fallback: boolean,
): boolean {
  if (value === undefined) {
    return fallback;
  }

  return value.trim().toLowerCase() === "true";
}

export type FeatureName = keyof typeof PossibleFeaturesMap;

export type FeatureValue<F extends FeatureName> =
  (typeof PossibleFeaturesMap)[F][number];

export type FeatureConfig = {
  [F in FeatureName]: FeatureValue<F>;
};
